import React from 'react';
import bem from 'utils/bem';
import Text from 'components/Text';
import IFrame from 'components/IFrame';

const { block, el } = bem('video-item');
export const VideoItem = ({src, title = null}) => {
    return (
        <div className={ block() } >
            { Boolean(title) && <div className={ el('video-title') }>
                <Text serif>{ title }</Text>
            </div> }
            <IFrame src={ src } />
        </div>
    )
}
